export default "__VITE_ASSET__DZZniNXD__"